module.exports = __webpack_public_path__ + "img/pwa_android.c8236393.jpeg";